
// 格子类型
export const LATTICE_TYPE_LIST = [  
  { label: '四方格', value: 'squareGrid' },  
  { label: '田字格', value: 'rectangleGrid' },  
  { label: '米字格', value: 'miGrid' },  
  { label: '回宫格', value: 'palaceGrid' },  
  { label: '长回宫格', value: 'longPalaceGrid' },  
  { label: '九宫格', value: 'ninePalaceGrid' },  
];
// 格子大小
export const LATTICE_SIZE_LIST = [
  { label: '较小', value: 'small', size: 36 },
  { label: '适中', value: 'medium', size: 46 },
  { label: '较大', value: 'large', size: 56 },
];
// 描红
export const PAINT_LIST = [
  { label: '不描', value: 'none' },
  { label: '半描', value: 'half' },
  { label: '全描', value: 'whole' },
];